<template>
  <div v-loading="loading">
    <el-button type="primary" @click="add" style="margin: 20px 0"
      >添加活动</el-button
    >
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="task_name" label="活动标题"> </el-table-column>
      <el-table-column prop="start_time" label="开始时间"> </el-table-column>
      <el-table-column prop="end_time" label="结束时间"> </el-table-column>
      <el-table-column prop="money" label="需消费金额"> </el-table-column>
      <el-table-column prop="gift_balance" label="赠送金额"> </el-table-column>
      <el-table-column prop="gift_integral" label="赠送积分"> </el-table-column>
      <el-table-column prop="coupon" label="赠送优惠券">
        <template slot-scope="scope">
          <div style="width: 100%;height:20px;overflow-y: auto" v-if="typeof scope.row.coupon == 'object'">
            <div v-for="e in scope.row.coupon">{{ e.name }} * {{ e.num }}</div>
          </div>
          <div v-else>
            {{scope.row.coupon}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="goods" label="参与油品"> </el-table-column>
      <el-table-column prop="room_ids" label="参与门店">
        <template slot-scope="scope">
          <div style="width: 100%;height:20px;overflow-y: auto">
            <div v-for="e in scope.row.room_name">{{ e.name }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="room_ids" label="操作">
        <template slot-scope="scope">
          <el-button size="small" @click="edit(scope.row.id)">编辑</el-button>
          <el-button size="small" type="danger" @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="margin-top: 20px"
      layout="prev, pager, next"
      :page-size="10"
      :total="total_num"
      @current-change="current_page"
    >
    </el-pagination>
  </div>
</template>
<script>
import { manage_del, manage_list } from "@/api/market";
import { mapGetters } from "vuex";
import { couponList } from "@/api/coupon";
import { goodsOptions } from "@/api/vip";
import { selectStoreList } from "@/api/storeManage";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      loading: true,
      tableData: [],
      page: 1,
      room_options: [],
      goodsarrs: [],
      sList: [],
      total_num:0
    };
  },
  mounted() {
    this.get_coupon();
    this.get_roomList();
    this.get_goods();
    setTimeout(() => {
      this.getList();
    }, 500);
  },
  methods: {
    //翻页
    current_page(val){
      this.page = val
      this.getList()
    },
    async del(id) {
      const res = await manage_del({ app_id: this.app_id, id: id });
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.getList()
      } else {
        this.$message.error(res.msg);
      }
    },
    add() {
      this.$router.push("add");
    },
    edit(id){
      this.$router.push({
        path:'edit',
        query:{
          id:id
        }
      })
    },
    getList() {
      let data = {
        app_id: this.app_id,
        page: this.page
      };
      manage_list(data).then(res => {
        if (res.code == 200) {
          this.total_num = res.data.num
          this.tableData = res.data.result;
          this.tableData.forEach((it, i) => {
            it.coupon = [];
            it.room_name = [];
            if (it.goods_id) {
              it.goods = this.goodsarrs.find(x => x.id == it.goods_id).name;
            }

            if (it.gift_coupon_info) {
              JSON.parse(it.gift_coupon_info).forEach(es => {
                console.log(es);
                this.sList.find(x => {
                  if (x.id == es.coupon_id) {
                    it.coupon.push({
                      name: x.title,
                      num: es.num
                    });
                  }
                });
              });
            }else {
              it.coupon = '无'
            }

            if (it.room_ids) {
              it.room_ids = it.room_ids.split(",");
              it.room_ids.forEach(e => {
                console.log(e);
                this.room_options.find(x => {
                  if (x.id == e) {
                    it.room_name.push(x);
                  }
                });
                it.goods = this.goodsarrs.find(x => x.id == it.goods_id).name;
              });
            }
          });
          this.loading = false;
        }
      });
    },
    //门店
    get_roomList() {
      selectStoreList({
        app_id: this.app_id
      }).then(res => {
        if (res.code == 200) {
          this.room_options = res.data;
        }
      });
    },
    //油品
    get_goods() {
      goodsOptions({ app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.goodsarrs = res.data;
        }
      });
    },
    //优惠券
    get_coupon() {
      couponList({ app_id: this.app_id, type: 0 }).then(res => {
        if (res.code == 200) {
          this.sList = res.data.result;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
